<app-header />

<div class="min-h-screen bg-gray-50 flex items-start justify-center pt-8 pb-12 px-4 sm:px-6 lg:px-8">
  <div class="max-w-md w-full space-y-8">
    <!-- Logo/Header -->
    <div>
      <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">
        Iniciar Sesión
      </h2>
      <p class="mt-2 text-center text-sm text-gray-600">
        Accede a tu cuenta para continuar
      </p>
    </div>

    <!-- Login Form -->
    <form class="mt-8 space-y-6" (ngSubmit)="onSubmit()">
      <div class="rounded-md shadow-sm space-y-4">
        <!-- Email -->
        <div>
          <label for="email" class="block text-sm font-medium text-gray-700 mb-1">
            Email
          </label>
          <input
            id="email"
            name="email"
            type="email"
            required
            [(ngModel)]="email"
            class="appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-lg focus:outline-none focus:ring-[#e8343f] focus:border-[#e8343f] focus:z-10 sm:text-sm"
            placeholder="Ingrese su email"
          />
        </div>

        <!-- Password -->
        <div>
          <label for="password" class="block text-sm font-medium text-gray-700 mb-1">
            Contraseña
          </label>
          <input
            id="password"
            name="password"
            type="password"
            required
            [(ngModel)]="password"
            class="appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-lg focus:outline-none focus:ring-[#e8343f] focus:border-[#e8343f] focus:z-10 sm:text-sm"
            placeholder="Ingrese su contraseña"
          />
        </div>
      </div>

      <!-- Error Message -->
      @if (errorMessage) {
        <div class="rounded-md bg-red-50 p-4">
          <div class="flex">
            <div class="flex-shrink-0">
              <svg class="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
              </svg>
            </div>
            <div class="ml-3">
              <p class="text-sm font-medium text-red-800">{{ errorMessage }}</p>
            </div>
          </div>
        </div>
      }

      <!-- Cloudflare Turnstile -->
      <div class="flex justify-center">
        <div id="turnstile-container"></div>
      </div>

      <!-- Submit Button -->
      <div>
        <button
          type="submit"
          [disabled]="isLoading"
          class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-lg text-white bg-[#e8343f] hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#e8343f] disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          @if (isLoading) {
            <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Iniciando sesión...
          } @else {
            Iniciar Sesión
          }
        </button>
      </div>

      <!-- Links -->
      <div class="flex flex-col space-y-2 text-sm">
        <a routerLink="/forgot-password" class="font-medium text-[#e8343f] hover:text-red-700">
          ¿Olvidaste tu contraseña?
        </a>
        <a routerLink="/resend-activation" class="font-medium text-[#e8343f] hover:text-red-700">
          Reenviar correo de activación
        </a>
      </div>

      <!-- Register Link -->
      <div class="text-center text-sm border-t border-gray-200 pt-6">
        <span class="text-gray-600">¿No tienes cuenta? </span>
        <a routerLink="/register" class="font-medium text-[#e8343f] hover:text-red-700">
          Regístrate aquí
        </a>
      </div>
    </form>
  </div>
</div>

<app-footer />
